var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:{
    'page-tab-component': true,
    'page-tab-driver-day': _vm.isDriverDay
  }},[_c('li',{staticClass:"tab",class:{
      'tab-active': _vm.selected === 0
    },on:{"click":function($event){return _vm.clickTab(0)}}},[_c('span',{staticClass:"tab-text"},[_vm._v("平台补贴")])]),_c('li',{staticClass:"tab",class:{
      'tab-active': _vm.selected === 1
    },on:{"click":function($event){return _vm.clickTab(1)}}},[_c('span',{staticClass:"tab-text"},[_vm._v("精选自费")])])])}
var staticRenderFns = []

export { render, staticRenderFns }